import { render } from "./PlanStep2.vue?vue&type=template&id=0b4af242&scoped=true"
import script from "./PlanStep2.vue?vue&type=script&lang=js"
export * from "./PlanStep2.vue?vue&type=script&lang=js"

import "./PlanStep2.vue?vue&type=style&index=0&id=0b4af242&scoped=true&lang=stylus"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4af242"]])

export default __exports__